import React from 'react';
import { brandLogos } from '../../data/mock';

const logoBlueFilter =
  'brightness(0) saturate(100%) invert(19%) sepia(76%) saturate(1790%) hue-rotate(214deg) brightness(92%) contrast(91%)';

const LogoItem = ({ logo }) => {
  return (
    <div className="shrink-0 h-12 md:h-14 flex items-center">
      <img
        src={logo.src}
        alt={logo.name}
        className={`h-11 md:h-12 w-auto object-contain opacity-85 hover:opacity-100 transition-opacity ${logo.className || ''}`}
        style={{ filter: logoBlueFilter }}
        loading="lazy"
      />
    </div>
  );
};

const LogoMarquee = () => {
  const items = [...brandLogos, ...brandLogos];
  return (
    <section className="py-14 md:py-20 border-y border-[#12367F]/10 overflow-hidden" style={{ background: '#FFFFFF' }}>
      <div className="container-x px-6 mb-12 md:mb-16">
        <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-[#12367F]/60 font-medium">
          Trusted by category-defining brands
        </p>
      </div>
      <div className="relative">
        <div className="flex gap-12 md:gap-16 items-center animate-marquee whitespace-nowrap will-change-transform" style={{ width: 'max-content' }}>
          {items.map((b, i) => (
            <LogoItem key={i} logo={b} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
